import { Check, Phone, Plus, Send, User } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { notify, countSegments, usPhoneFormatValid, can_visit, userAccessToken } from "../../helpers";
import { Config } from "../../Config";
import axios from "axios";
import Inputmask from "inputmask";
import { Link } from "react-router-dom";
import { getSMSLimitData } from "../../services/message";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function MessageModal(props) {
  const {
    patient_id = null,
    last_name = "",
    first_name = "",
    phone = "",
    message_type = "Single",
    messageTemplate = [],
    account_id,
    location_id,
    activeModal,
    setActiveModal = () => {},
    setSmsLimit = () => {},
    previousScrollPosition = 0,
    fullName = ""
  } = props;

  const [formData, setFormData] = useState({
    account_id: account_id,
    notification_type: message_type,
    message_body: "",
    receiver_address: phone,
    location_id: location_id,
    patient_id: patient_id,
  });
  const [segments, setSegments] = useState(0);
  const [chooseTemplate, setChooseTemplate] = useState(null);
  const dropdownRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "receiver_address") {
      const phoneInputs = document.querySelectorAll(".us_phone");
      Inputmask({
        mask: "(999) 999-9999",
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }

    if (name === "message_body") {   
      setFormData({
        ...formData,
        [name]: value,
      });
      setSegments(countSegments(value));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const getSMSLimit = async() => {
    const result = await getSMSLimitData(account_id);
    if (result) {
      setSmsLimit(result?.data);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(can_visit("_single_message")){
      if (usPhoneFormatValid(formData.receiver_address) === null) {
        notify("error", "Invalid phone number");
      } else {
        try {
          e.target.disabled = true;
          const response = await axios.post(
            Config.notificationServerUrl + "/message-transaction/regular-create",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                Authorization: `Bearer ${
                  userAccessToken()
                }`,
              },
            }
          );

          if (response) {
            if(response?.detail){
              notify("error", response?.detail);
            } else {
              // Clean form data
              setFormData({
                ...formData,
                message_body: "",
              });
              
              notify(
                "success",
                "Message " +
                response.data.status +
                " to " +
                response.data.receiver_address
              );

              e.target.disabled = false;
              handleDrawerClose();
              setTimeout(() => {
                getSMSLimit();
              }, 5000);
            }
          }
        } catch (error) {
          notify("error", error.message);
          e.target.disabled = false;
        }
      }
    }
  };

  const allMessageTemplate = messageTemplate?.map((option) => ({
    value: option?.id,
    label: option?.title,
  }));

  const handleTemplateChange = (selectedOption) => {
    const selectedTemplateId = selectedOption.value;
    setChooseTemplate(selectedTemplateId);
    const selectedTemplate = messageTemplate.find(
      (template) => template.id === parseInt(selectedTemplateId)
    );
    if (selectedTemplate) {
      let messageBody = selectedTemplate.body;
      let nameParts = fullName ? fullName.trim().split(" ") : [];
      let resolvedFirstName = first_name || (nameParts.length > 1 ? nameParts.slice(1).join(" ") : "");
      let resolvedLastName = last_name || (nameParts.length > 0 ? nameParts[0] : "");

      let updateMessageBody = messageBody
        .replace("[last_name]", resolvedLastName)
        .replace("[first_name]", resolvedFirstName);

      setFormData({
        ...formData,
        message_body: updateMessageBody,
      });
      setSegments(countSegments(updateMessageBody));
    }
  };

  useEffect(() => {
    setFormData({
      ...formData,
      location_id: location_id,
      account_id: account_id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 large">
            <Drawer.Title className="sr-only">Send Message</Drawer.Title>
            <Drawer.Description className="sr-only">Send message of a parient</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              {can_visit("_single_message") && (
                <div className="docpro_modal">
                  <form onSubmit={handleSubmit} className="modal_height_100">
                    <div>
                      <h2 className="docpro_fs_24 docpro_mb_0">Send a message</h2>
                      <Spacing lg="20" sm="20" />
                      {(((last_name + first_name).length >= 2) || fullName) && (
                        <>
                          <label className="docpro_fw_500 docpro_primary_color">
                            Patient Name
                          </label>
                          <div className="docpro_form_field_with_icon">
                            <input
                              name="full_name"
                              type="text"
                              defaultValue={fullName || last_name + " " + first_name}
                              className="docpro_form_field size_lg"
                              readOnly
                            />
                            <User
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                            <Check
                              width={20}
                              height={20}
                              className="docpro_form_field_icon"
                            />
                          </div>
                          <Spacing lg="20" sm="20" />
                        </>
                      )}

                      <label className="docpro_fw_500 docpro_primary_color">
                        Patient Number <span className="docpro_red_color">*</span>
                      </label>
                      <div className="docpro_form_field_with_icon_group">
                        <select className="docpro_form_field size_lg">
                          <option value="1">+1</option>
                        </select>
                        <input
                          type="text"
                          name="receiver_address"
                          className="docpro_form_field size_lg us_phone"
                          onChange={handleChange}
                          value={phone.length > 9 ? phone : formData.receiver_address}
                          readOnly={!phone.length > 9}
                          minLength={9}
                          maxLength={16}
                          required
                        />
                        <Phone
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                        <Check
                          width={20}
                          height={20}
                          className="docpro_form_field_icon"
                        />
                      </div>
                      <Spacing lg="20" sm="20" />
                      <div className="docpro_label_group">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Template
                        </label>
                        <Link to="/message-templates" className="docpro_text_btn_2">
                          <Plus width={16} height={16} />
                          Create new template
                        </Link>
                      </div>
                      <Select
                        options={allMessageTemplate}
                        placeholder="Search Template..."
                        isSearchable
                        value={allMessageTemplate?.find((option) => option?.value === chooseTemplate) || null}
                        onChange={handleTemplateChange}
                        className="react-select-container w-full"
                        classNamePrefix="react-select"
                        filterOption={(option, rawInput) => {
                          const words = rawInput.toLowerCase().split(" ");
                          return words.every((word) =>
                            option.label.toLowerCase().includes(word)
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '40px',
                            borderColor: 'var(--border)',
                            borderRadius: '8px'
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 1050,
                            marginTop: '-2px',
                            borderRadius: '0 0 3px 3px',
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 1050,
                            padding: 0
                          }),
                        }}
                      />
                      <Spacing lg="20" sm="20" />
                      <label className="docpro_fw_500 docpro_primary_color">
                        Message <span className="docpro_red_color">*</span>
                      </label>
                      <textarea
                        required
                        minLength={2}
                        name="message_body"
                        className="docpro_form_field size_lg"
                        cols="30"
                        rows="5"
                        value={formData.message_body}
                        onChange={handleChange}
                        placeholder="Write your message here..."
                      ></textarea>
                      <div>
                        Total segments:{" "}
                        <span className="docpro_badge docpro_badge_success">
                          {segments}
                        </span>
                      </div>
                      <Spacing lg="20" sm="20" />
                    </div>
                    {can_visit("_single_message") && (
                      <button
                        type="submit"
                        className="docpro_bordered_btn size_lg width_100 docpro_fw_600 docpro_white_color docpro_filed_btn docpro_mt_auto"
                      >
                        <Send width={20} height={20} />
                        <span>Send SMS</span>
                      </button>
                    )}
                  </form>
                </div>
              )}
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
